import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome, FaUser, FaShieldAlt, FaFileAlt, FaBriefcase, FaCogs, FaSignOutAlt,
  FaBoxes, FaChevronDown, FaChevronRight, FaTruck,
  FaExchangeAlt,
  FaChartBar,
  FaQuestionCircle,
  FaBook,
  FaThLarge
} from "react-icons/fa";
import axios from 'axios';
import { FaTruckDroplet } from 'react-icons/fa6';

const Sidebar = ({ user, titre }) => {


  const [openToursSubmenu, setOpenToursSubmenu] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);
  const user_id = localStorage.getItem('userId');
  const groupe_id = localStorage.getItem('groupe_id');
  const [accesGroupe, setAccesGroupe] = useState(() => {
    // Initialiser avec les accès stockés dans localStorage si disponibles
    const storedAccess = localStorage.getItem('accesGroupe');
    return storedAccess ? JSON.parse(storedAccess) : [];
  });

  const activeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    borderLeft: '4px solid white',
  };

  const defaultStyle = {
    backgroundColor: 'transparent',
    borderLeft: 'none',
  };

  const sidebarStyle = {
    // background: 'linear-gradient(to bottom, #273748, #28416F)',
    // color: 'white',
    // height: 'auto',
    background: 'linear-gradient(to bottom, #273748, #28416F)',
    color: 'white',
    // height: '100vh',
    // position: 'fixed',
  };

  const verifGroupeDeLutilisateur = async () => {
    const groupeStored = localStorage.getItem('groupe');
    const accesGroupeStored = localStorage.getItem('accesGroupe');

    const token = localStorage.getItem('access_token')
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOTE}/groupe-de-l-utilisateur/${user_id}/`,
        {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem('groupe', data.group_ids);
      }
    } catch (error) {
      console.error('Erreur lors de la vérification du groupe', error);
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupeDeLutilisateur();
    }
  }, [user_id]);

  useEffect(() => {
    const token = localStorage.getItem('access_token')
    const verifGroupe = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe_id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
        if (response.status === 200) {
          const data = response.data;
          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces.map((item) =>
              item.acces
                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                : []
            ).flat();
            setAccesGroupe(cleanedAccessArray);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du groupe', error);
      }
    };

    if (user_id && (!accesGroupe.length || !localStorage.getItem('accesGroupe'))) {
      verifGroupe();
    }
  }, [user_id, groupe_id]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem("accesGroupe");
    localStorage.removeItem("token");
    window.location.replace('/');
  };

  return (
    <nav className="navbar-default navbar-static-side" role="navigation" style={sidebarStyle}>
      <div className="sidebar-collapse">
        <div className="" style={{ marginBottom: '100px', width: 'auto' }}>
          <ul className="nav metismenu" id="side-menu">
            {/* Logo & Nom de l'application */}
            <li className="nav-header" style={{ marginBottom: '0', padding: '10px 0' }}>
              <div className="profile-element ml-4">
                <span className="font-bold text-white"><h2>TRANSPORT PRO</h2></span>
              </div>
            </li>


            <li className={
              isActive('/Menu') ||
                isActive('/manuel-utilisation') ||
                isActive('/Mon-profil') ||
                isActive('/Liste-enrolement') ||
                isActive('/Enroler-vehicule') ||
                isActive('/Modifier-enrolement') ||
                isActive('/Liste-pieces') ||
                isActive('/Consulter-pieces-vehicule') ||
                isActive('/Renouveler-pieces-vehicule') ||
                isActive('/Gestion-des-tours') ||
                isActive('/Gestion-des-tours-national') ||
                isActive('/Gestion-des-tours-international') ||
                isActive('/Liste-declaration-fret') ||
                isActive('/Enregistrer-fret') ||
                isActive('/Modifier-fret') ||
                isActive('/Admin') ||
                isActive('/Parcs') ||
                isActive('/Rapport-et-statistique') ||
                isActive('/Liste-groupe') ||
                isActive('/Configurer-groupe') ||
                isActive('/Elementaires') ||
                isActive('/Liste-genres-vehicules') ||
                isActive('/Liste-types-vehicules') ||
                isActive('/Liste-assureurs') ||
                isActive('/Liste-parametre') ||
                isActive('/Liste-frets') ||
                isActive('/Corbeilles') ||
                isActive('/Liste-fret-corbeille') ||
                isActive('/Liste-conducteur') ||
                isActive('/Liste-nature') ||
                isActive('/Enrolement-admin') ||
                isActive('/Pieces-admin') ||
                isActive('/Admin-consulter-pieces-vehicule') ||
                isActive('/Admin-Renouveler-pieces-vehicule') ||
                isActive('/Liste-utilisateur') ||
                isActive('/Liste-parc') ||
                isActive('/Liste-journalisation') ||
                isActive('/Corbeilles') ||
                isActive('/Enrolement-archives') ||
                isActive('/Modifier-vehicule_admin') ||
                isActive('/Factures-GIE') ||
                isActive('/Manuel-utilisation')
                ? 'active' : ''} title="Accueil">
              <Link className='text-white' to={{
                pathname: `/Menu`,
                state: { user, titre }
              }}>
                <FaThLarge /> <span className="nav-label ml-2">Accueil</span>
              </Link>
            </li>

            {/* Rapport-et-statistique */}
            {/* {accesGroupe.includes('Rapport_et_statistique') && (
              <li className={isActive('/Rapport-et-statistique') ? 'active' : ''} title="Rapport et statistique">
                <Link className='text-white' to="/Rapport-et-statistique">
                  <FaChartBar /> <span className="nav-label ml-2">Rapport et statistique</span>
                </Link>
              </li>
            )} */}

            {/* Enrôlement */}
            {/* {accesGroupe.includes('Enrolement') && (
              <li className={
                isActive('/Liste-enrolement') ||
                  isActive('/Enroler-vehicule') ||
                  isActive('/Modifier-enrolement')
                  ? 'active' : ''}
                title="Enrôlement">
                <Link className='text-white' to="/Liste-enrolement">
                  <FaTruck /> <span className="nav-label ml-2">Enrôlement</span>
                </Link>
              </li>
            )} */}

            {/* Suivi document */}
            {/* {accesGroupe.includes('Suivi_doc') && (
              <li className={isActive('/Liste-pieces') ||
                isActive('/Consulter-pieces-vehicule') ||
                isActive('/Renouveler-pieces-vehicule') ? 'active' : ''} title="Suivi Document">
                <Link className='text-white' to="/Liste-pieces">
                  <FaFileAlt /> <span className="nav-label ml-2">Suivi Document</span>
                </Link>
              </li>
            )} */}


            {/* {(accesGroupe.includes('Fret') || accesGroupe.includes('gestion_tours_national') || accesGroupe.includes('gestion_tours_international')) && (
              <li className={
                isActive('/Gestion-des-tours') ||
                  isActive('/Gestion-des-tours-national') ||
                  isActive('/Gestion-des-tours-international') ||
                  isActive('/Liste-declaration-fret') ||
                  isActive('/Enregistrer-fret') ||
                  isActive('/Modifier-fret')
                  ? 'active' : ''
              } title="Gestion des tours">
                <Link className='text-white' to="/Gestion-des-tours">
                  <FaExchangeAlt /><span className="nav-label ml-2">Gestion des tours</span>
                </Link>
              </li>
            )} */}


            {/* Administration */}
            {/* {accesGroupe.includes('Administration') && (
              <li className={
                isActive('/Admin') ||
                  isActive('/Liste-groupe') ||
                  isActive('/Configurer-groupe') ||
                  isActive('/Elementaires') ||
                  isActive('/Liste-genres-vehicules') ||
                  isActive('/Liste-types-vehicules') ||
                  isActive('/Liste-assureurs') ||
                  isActive('/Liste-parametre') ||
                  isActive('/Liste-frets') ||
                  isActive('/Corbeilles') ||
                  isActive('/Liste-fret-corbeille') ||
                  isActive('/Liste-conducteur') ||
                  isActive('/Liste-nature') ||
                  isActive('/Enrolement-admin') ||
                  isActive('/Pieces-admin') ||
                  isActive('/Admin-consulter-pieces-vehicule') ||
                  isActive('/Admin-Renouveler-pieces-vehicule') ||
                  isActive('/Liste-utilisateur') ||
                  isActive('/Liste-parc') ||
                  isActive('/Liste-journalisation') ||
                  isActive('/Corbeilles') ||
                  isActive('/Enrolement-archives') ||
                  isActive('/Modifier-vehicule_admin')
                  ? 'active' : ''}
                title="Administration">
                <Link className='text-white' to="/Admin">
                  <FaCogs /> <span className="nav-label ml-2">Administration</span>
                </Link>
              </li>
            )} */}

            {/* Profil utilisateur */}
            {/* <li className={isActive('/Mon-profil') ? 'active' : ''} title="Mon Profil">
              <Link className='text-white' to={{
                pathname: `/Mon-profil`,
                state: { user, titre }
              }}>
                <FaUser /> <span className="nav-label ml-2">Mon Profil</span>
              </Link>
            </li>
            {
              accesGroupe.includes('Administration') ? (
                <li className={isActive('/Manuel-utilisation-admin') ? 'active' : ''} title="Manuel d'utilisation admin">
                  <Link
                    to="/manuel-utilisation-admin"
                    className='text-white'
                    title="Manuel d'utilisation administrateur"
                  >
                    <FaBook />
                    <span className="nav-label ml-2">Manuel d'utilisation</span>
                  </Link>
                </li>
              ) : (
                <li className={isActive('/Manuel-utilisation') ? 'active' : ''} title="Manuel d'utilisation">
                  <Link
                    to="/manuel-utilisation"
                    className='text-white'
                    title="Manuel d'utilisation"
                  >
                    <FaQuestionCircle />
                    <span className="nav-label ml-2">Manuel d'utilisation</span>
                  </Link>
                </li>
              )
            } */}

            {/* Déconnexion */}
            <li className='ml-2' style={defaultStyle} title="Déconnexion">
              <Link onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', width: '100%', textAlign: 'left', padding: '10px 15px' }}>
                <FaSignOutAlt /> <span className="nav-label ml-2">Déconnexion</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Guide d'utilisation - positionné en bas et collé */}
        {/* <div className="d-flex justify-content-center" style={{ 
          padding: '15px', 
          borderTop: '1px solid rgba(255,255,255,0.1)',
          marginTop: '0', // Pousse le div vers le bas
          flexShrink: 0, // Empêche le rétrécissement
          // position: 'absolute'
        }}>
          <Link 
            to="/manuel-utilisation" 
            className='text-white ' 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              textDecoration: 'none',
              // padding: '5px 15px'
            }}
            title="Manuel d'utilisation"
          >
            <FaQuestionCircle /> 
            <span className="nav-label ml-2">Manuel d'utilisation</span>
          </Link>
        </div> */}
      </div>
    </nav>
  );
};

export default Sidebar;